import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, UtensilsCrossed, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import Seo from "@/components/Seo";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-[#2e2e2e] border border-white/25 rounded-sm px-4 py-3 text-white placeholder:text-white/50 outline-none focus:border-[#C9A66B] focus:ring-1 focus:ring-[#C9A66B]/60 transition-colors";

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center px-5" data-testid="admin-login-page">
      <Seo title="Owner Login — Mayuresh Caterers" description="Admin login" />
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 justify-center mb-8">
          <span className="w-11 h-11 flex items-center justify-center bg-[#C9A66B]"><UtensilsCrossed size={22} className="text-[#1A1A1A]" /></span>
          <span className="serif text-2xl font-semibold text-white">Mayuresh Caterers</span>
        </div>
        <div className="bg-[#232323] border border-white/10 rounded-sm p-8">
          <div className="flex items-center gap-2 mb-6"><Lock size={16} className="text-[#C9A66B]" /><h1 className="text-xl font-semibold text-white serif">Owner Login</h1></div>
          <form onSubmit={submit} className="space-y-4">
            <input className={inputCls} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
            <input className={inputCls} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
            <button type="submit" disabled={loading} className="btn-gold w-full py-3.5 rounded-sm flex items-center justify-center gap-2 disabled:opacity-60" data-testid="login-submit">
              {loading ? <Loader2 size={18} className="animate-spin" /> : null} Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
